import React, { Fragment } from 'react'
import estilos from './ViverosComponent.module.css'
import maguey from '../../../../../img/maguey.png'
import grass from '../../../../../img/grass.png'
import { useDispatch, useSelector } from 'react-redux'
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Paper, Typography } from '@mui/material';
import { TextField } from '@mui/material'
import moment from 'moment'
import { actualizaVivierosCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../../redux/AppDucks';
import ModalHistorialCambiosComponent from '../ModalHistorialCambiosComponent'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';

function ViverosComponent(props) {
    const dataUser = useSelector(store => store.Usuario.user)
    const [editar, setEditar] = React.useState(false)
    const dispatch = useDispatch()

    const [nombreparaje, setNombreParaje] = React.useState(props?.data?.nombreparaje?.toUpperCase())
    const [localidad, setLocalidad] = React.useState(props?.data?.localidad?.toUpperCase())
    const [municipio, setMunicipio] = React.useState(props?.data?.municipio?.toUpperCase())
    const [distrito, setDistrito] = React.useState(props?.data?.distrito?.toUpperCase())
    const [estado, setEstado] = React.useState(props?.data?.estado?.toUpperCase())
    const [calle, setCalle] = React.useState(props?.data?.calle?.toUpperCase())
    const [numeroexterior, setNumeroExterior] = React.useState(props?.data?.numeroexterior?.toUpperCase())
    const [codigopostal, setCodigoPostal] = React.useState(props?.data?.codigopostal?.toUpperCase())

    const [openModal, setOpenModal] = React.useState(false);
    const handleOpenModal = () => { setOpenModal(true) }
    const handleCloseModal = () => { setOpenModal(false) }
    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0, fontFamily: 'Montserrat' }} className='text-center'>
                            <h3 className='text-center'><b>ADVERTENCIA</b></h3>
                            <p className='mt-3'>¿Está seguro que desea actualizar la información del vivero seleccionado?</p>
                        </Typography>
                        <br />
                        <ThemeProvider theme={theme}>
                            <div className='row'>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModal() }}>Cancelar</Button>
                                </div>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { btnContinuar() }}>Continuar</Button>
                                </div>
                            </div>
                        </ThemeProvider>
                    </Box>
                </Modal>
            </div>
        )
    }
    const btnContinuar = async () => {
        const fechaHoy = moment().format('YYYY-MM-DD')

        await dispatch(actualizarLoadingApp_true())

        let fechainscripcion = new Date(fechaHoy).toISOString()

        let dataActualizar = {
            datacambio: {
                nombreparaje: nombreparaje?.toUpperCase(), localidad: localidad?.toUpperCase(), municipio: municipio?.toUpperCase(),
                distrito: distrito?.toUpperCase(), estado: estado?.toUpperCase(), calle: calle?.toUpperCase(), numeroexterior: numeroexterior?.toUpperCase(),
                codigopostal: codigopostal?.toUpperCase(), idvivero: props?.data?.idvivero
            },
            idvivero: props?.data?.idvivero, usuariocambio: dataUser?.[0]?.usuario, fechacambio: fechainscripcion
        }
        await dispatch(actualizaVivierosCliente(dataActualizar))
        handleCloseModal()
        setEditar(false)
        props?.setIsModificacion(true)
        await dispatch(actualizarLoadingApp_false())
    }
    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.viveroclientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(props?.data?.viveroclientehistorial)
        setOpenModalHistorial(true)
    }
    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 450,
        height: 250,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '5px'
    };
    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                {!editar &&
                    <div className={`${estilos.section} text-center py-5 py-md-0`}>
                        <div className={`${estilos.card3dWrap} mx-auto`}>
                            <div className={`${estilos.card3dWrapper} mx-auto`}>
                                <div className={`${estilos.cardBack}`}>
                                    <div className={props?.data.isbaja ? `${estilos.pricingWrapBaja}` : `${estilos.pricingWrap}`}>
                                        <h4 className={`${estilos.h4} mb-5`}></h4>
                                        <div className='row' style={{ marginTop: '50%', marginRight: '10%', fontFamily: 'Montserrat' }}>
                                            {props?.data?.isbaja == false &&
                                                <div style={{ display: 'flex', justifyContent: 'end' }} >
                                                    <Tooltip title="Ver historial de cambios">
                                                        <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                                            <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            }
                                            {props?.data?.isbaja == true &&
                                                <div style={{ display: 'flex', justifyContent: 'end' }} >
                                                    <IconButton size="large" sx={{ p: 1 }} disableFocusRipple disableRipple disabled >
                                                        <HistoryRoundedIcon fontSize="inherit" sx={{ color: 'white' }} />
                                                    </IconButton>
                                                </div>
                                            }
                                            <p className="mb-4 ps-5 pe-5"><b>Vivero:</b> {props?.data?.nombreparaje?.toUpperCase()}</p>
                                            <p className="mb-4 ps-5 pe-5"><b>Domicilio:</b> {props?.data?.calle?.toUpperCase() + ', ' + props?.data?.numeroexterior?.toUpperCase() + ', ' + props?.data?.localidad?.toUpperCase() + ', ' +
                                                props?.data?.municipio?.toUpperCase() + ', ' + props?.data?.distrito?.toUpperCase() + ', ' + props?.data?.estado?.toUpperCase() + ', ' + props?.data?.codigopostal?.toUpperCase()}</p>
                                            {!props?.data?.isbaja && !editar && dataUser?.[0]?.idrol == 1 &&
                                                <div className="col-md-12 mt-3">
                                                    <Button variant="contained" color="primary" style={{ width: '65%' }} onClick={() => setEditar(true)}>Editar predio</Button>
                                                </div>
                                            }
                                        </div>
                                        <div className={`${estilos.imgWrap} ${estilos.img} ${estilos.img2}`}>
                                            <img src={grass} alt="" />

                                        </div>
                                        <div className={`${estilos.imgWrap} ${estilos.img} ${estilos.img7}`}>
                                            <img src={maguey} alt="" style={{ width: '110%' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {editar &&
                    <div className={`${estilos.section} text-center py-5 py-md-0`}>
                        <div className={`${estilos.card3dWrap} mx-auto`}>

                            <div className={`${estilos.card3dWrapper} mx-auto`}>
                                <div className={`${estilos.cardBack} row`}>
                                    <div className='col-12 mt-3 text-start ps-5 pe-5'>
                                        <TextField id="standard-basic" label='Nombre Paraje' variant="standard" hiddenLabel style={{ width: '100%', color: 'black' }}
                                            value={nombreparaje} onChange={e => setNombreParaje(e.target.value?.toUpperCase())} disabled={!editar} />
                                    </div>
                                    <div className='col-12 mt-3 text-start ps-5 pe-5'>
                                        <TextField id="standard-basic" label='Calle' variant="standard" hiddenLabel style={{ width: '100%', color: 'black' }}
                                            value={calle} onChange={e => setCalle(e.target.value?.toUpperCase())} disabled={!editar} />
                                    </div>
                                    <div className='col-12 mt-3 text-start ps-5 pe-5'>
                                        <TextField id="standard-basic" label='Número Exterior' variant="standard" hiddenLabel style={{ width: '100%', color: 'black' }}
                                            value={numeroexterior} onChange={e => setNumeroExterior(e.target.value?.toUpperCase())} disabled={!editar} />
                                    </div>
                                    <div className='col-12 mt-3 text-start ps-5 pe-5'>
                                        <TextField id="standard-basic" label='Localidad' variant="standard" hiddenLabel style={{ width: '100%', color: 'black' }}
                                            value={localidad} onChange={e => setLocalidad(e.target.value?.toUpperCase())} disabled={!editar} />
                                    </div>
                                    <div className='col-12 mt-3 text-start ps-5 pe-5'>
                                        <TextField id="standard-basic" label='Municipio' variant="standard" hiddenLabel style={{ width: '100%', color: 'black' }}
                                            value={municipio} onChange={e => setMunicipio(e.target.value?.toUpperCase())} disabled={!editar} />
                                    </div>
                                    <div className='col-12 mt-3 text-start ps-5 pe-5'>
                                        <TextField id="standard-basic" label='Distrito' variant="standard" hiddenLabel style={{ width: '100%', color: 'black' }}
                                            value={distrito} onChange={e => setDistrito(e.target.value?.toUpperCase())} disabled={!editar} />
                                    </div>
                                    <div className='col-6 mt-3 text-start ps-5'>
                                        <TextField id="standard-basic" label='Estado' variant="standard" hiddenLabel style={{ width: '100%', color: 'black' }}
                                            value={estado} onChange={e => setEstado(e.target.value?.toUpperCase())} disabled={!editar} />
                                    </div>
                                    <div className='col-6 mt-3 text-start '>
                                        <TextField id="standard-basic" label='Codigo Postal' variant="standard" hiddenLabel style={{ width: '100%', color: 'black' }}
                                            value={codigopostal} onChange={e => setCodigoPostal(e.target.value?.toUpperCase())} disabled={!editar} />
                                    </div>
                                    <div className='row mt-4'>
                                        <div className='col-6 col-md-6 justify-content-center'>
                                            <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => setEditar(false)}>Cancelar</Button>
                                        </div>
                                        <div className='col-6 col-md-6 justify-content-center'>
                                            <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => handleOpenModal()}>Guardar cambios</Button>
                                        </div>
                                    </div>
                                    <div className={props?.data.isbaja ? `${estilos.pricingWrapBaja}` : `${estilos.pricingWrap}`}>
                                        <h4 className={`${estilos.h4} mb-5`}></h4>
                                        <div className='row' style={{ marginTop: '60%', fontFamily: 'Montserrat' }}>
                                            <p className="mt-3 mb-4 ps-5 pe-5"><b>Predio:</b> {props?.data?.nombreparaje?.toUpperCase()}</p>
                                            <p className="mb-4 ps-5 pe-5"><b>Tipo Plantación:</b> {props?.data?.cultivado ? 'CULTIVADO' :
                                                props?.data?.semicultivado ? 'SEMICULTIVADO' :
                                                    props?.data?.silvestre ? 'SILVESTRE' :
                                                        ''}</p>
                                            <p className="mb-4 ps-5 pe-5"><b>Domicilio:</b> {props?.data?.localidad?.toUpperCase() + ', ' + props?.data?.municipio?.toUpperCase() + ', ' +
                                                props?.data?.distrito?.toUpperCase() + ', ' + props?.data?.estado?.toUpperCase()}</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {modalComponent()}
                {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Viveros"} />}

            </ThemeProvider>
        </Fragment >
    )
}

export default ViverosComponent